import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import css_248z from './file-download.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
class FileDownload extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.divider = false;
        this.columns = 1;
        this.blockWidth = 0;
        this.headingSlot = null;
        this.handleResize = () => {
            if (this.element)
                this.setColumns(this.element);
        };
        this.handleLoad = () => {
            if (this.element)
                this.setColumns(this.element);
        };
        this._resizeObserver = null;
    }
    getParentTabElement() {
        if (!(this.parentNode instanceof HTMLElement))
            return null;
        const parentTagName = this.parentNode.tagName.toLowerCase();
        return parentTagName === 'tab-item' || parentTagName === 'tab-item-updated'
            ? this.parentNode
            : null;
    }
    setBlockWidth(tabsContainer) {
        var _a;
        // tabs-container-updated uses light DOM (no shadowRoot); fall back to the
        // element itself so querySelector still finds .content.
        const root = (_a = tabsContainer.shadowRoot) !== null && _a !== void 0 ? _a : tabsContainer;
        const content = root.querySelector('.content');
        if (content)
            this.blockWidth = content.offsetWidth;
    }
    setColumns(element) {
        var _a;
        this.blockWidth = element.offsetWidth;
        const parentTab = this.getParentTabElement();
        if (parentTab) {
            const tabsContainer = parentTab.closest('tabs-container, tabs-container-updated');
            if (tabsContainer)
                this.setBlockWidth(tabsContainer);
        }
        if ((_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains('accordion-inner')) {
            const tabsContainer = this.parentElement.closest('tabs-container, tabs-container-updated');
            if (tabsContainer)
                this.setBlockWidth(tabsContainer);
        }
        this.columns = 1;
        if (this.blockWidth > 719 && window.innerWidth > 767)
            this.columns = 2;
        if (this.blockWidth > 1256 && window.innerWidth > 1365)
            this.columns = 3;
        if (this.blockWidth > 1758 && window.innerWidth > 1919)
            this.columns = 4;
        const downloadItems = Array.from(element.querySelectorAll('file-download-item'));
        downloadItems.forEach(item => {
            var _a;
            const el = (_a = item.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.file-download-item');
            el === null || el === void 0 ? void 0 : el.setAttribute('data-in-row', `${this.columns}`);
        });
    }
    _addEventListeners() {
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('load', this.handleLoad);
    }
    _removeEventListeners() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('load', this.handleLoad);
    }
    connectedCallback() {
        super.connectedCallback();
        this._addEventListeners();
    }
    disconnectedCallback() {
        var _a;
        this._removeEventListeners();
        (_a = this._resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        this._resizeObserver = null;
    }
    firstUpdated() {
        var _a;
        this.element = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.file-download__container');
        setDataAttributes(this, 'headline-title', null);
        setLineClamp(this, 80, null);
        // Recalculate columns whenever the container's rendered size changes.
        // This handles the case where file-download starts inside a hidden tab
        // (offsetWidth = 0 → columns = 1 / full-width) and the tab is later
        // activated – the ResizeObserver fires and sets the correct column count.
        if (this.element) {
            this._resizeObserver = new ResizeObserver(() => {
                if (this.element.offsetWidth > 0) {
                    this.setColumns(this.element);
                }
            });
            this._resizeObserver.observe(this.element);
        }
    }
    render() {
        var _a;
        return $ `<div class="file-download ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''} ${this.divider ? 'divider' : ''}" ${this.rtl || isRTL() ? 'rtl' : ''}><hr class="file-download__separator"><slot name="headline-title"></slot><div class="file-download__container columns-${this.columns}"><slot name="file-download-item"></slot></div></div>`;
    }
}
FileDownload.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    e({ type: Boolean })
], FileDownload.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], FileDownload.prototype, "divider", void 0);
__decorate([
    t()
], FileDownload.prototype, "columns", void 0);
__decorate([
    t()
], FileDownload.prototype, "blockWidth", void 0);
__decorate([
    t()
], FileDownload.prototype, "element", void 0);
__decorate([
    t()
], FileDownload.prototype, "headingSlot", void 0);
customElements.define('file-download', FileDownload);

export { FileDownload };
